"use client";

import React from "react";
import { Zap, Video, FileText, Briefcase, Mic, Share2, CircleCheck, ExternalLink } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const elixirs = [{
  id: "speaking",
  name: "Speaking",
  description: "Visionary presentations on the future of AI, cloud computing, and digital transformation for global conferences.",
  tag: "Event Booking",
  icon: Mic,
  deliverables: "60-min Keynote, Custom Slide Deck, Q&A Session, VIP Meet & Greet",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "video-participation",
  name: "Video Participation",
  description: "High-impact participation in corporate videos, technical explainers, and promotional content for AI and cloud brands.",
  tag: "Project Based",
  icon: Video,
  deliverables: "On-camera Presence, Technical Scripting, Professional Audio, Social Clips",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "youtube-sponsorships",
  name: "YouTube Sponsorships",
  description: "Strategic placement and authentic endorsements within high-traffic technical video content. I operate two YouTube channels—one focused on cloud computing and the other on AI—with a combined 0.5 million subscribers, supporting both live and pre-recorded content.",
  tag: "Campaign Based",
  icon: Share2,
  deliverables: "Dedicated Segments, Link Placements, Audience Analytics, Brand Integration",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "content-creation-promotion",
  name: "Content Creation and Promotion",
  description: "Developing and amplifying authoritative multi-channel content strategies that establish brands as thought leaders. I operate two YouTube channels—one focused on cloud computing and the other on AI—with a combined 0.5 million subscribers, supporting both live and pre-recorded content.",
  tag: "Strategic Retainer",
  icon: Zap,
  deliverables: "Content Strategy, Editorial Calendar, Multi-platform Promotion, Engagement Reports",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "white-paper-dev",
  name: "White Paper Development",
  description: "Deep-dive technical research and authoritative white papers that provide clarity on emerging technology trends.",
  tag: "Deliverable Based",
  icon: FileText,
  deliverables: "Primary Research, 15+ Page Report, Data Visuals, Executive Summary",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "article-development",
  name: "Article Development",
  description: "Crafting high-quality, SEO-optimized articles for major industry publications and corporate blogs.",
  tag: "Per Article",
  icon: FileText,
  deliverables: "Topic Research, SEO Optimization, Custom Graphics, Distribution Plan",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "consulting",
  name: "Consulting",
  description: "Strategic advisory for technology firms looking to refine their market positioning and product-market fit.",
  tag: "Strategic Advisory",
  icon: Briefcase,
  deliverables: "Market Analysis, Product Roadmap, Competitive Audit, Executive Brief",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "ai-cloud-mentoring",
  name: "AI and Cloud Project Mentoring",
  description: "Direct mentorship for senior leaders navigating the complexities of AI adoption and organizational change.",
  tag: "Hourly Engagement",
  icon: Zap,
  deliverables: "Weekly 1:1 Calls, Resource Library, Direct Access, Project Review",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}, {
  id: "custom-engagements",
  name: "Custom Engagements",
  description: "Tailored support activities designed to meet specific organizational goals in the tech ecosystem.",
  tag: "Flexible",
  icon: Zap,
  deliverables: "Custom Scope, Dedicated Support, Milestone Tracking, Specialized Expertise",
  ratesUrl: "https://drive.google.com/file/d/1i9sAOqS1wAKn2OVzDXKxLHc7ZDrHz58Z/view?usp=sharing"
}];
export default function StrategicAdvisoryMentorship() {
  return <section data-section-id="261406" id="strategic-advisory-mentorship" className="bg-background text-foreground relative py-24 md:py-40 overflow-hidden border-y border-border/50">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/blueprint_overlay_pattern.png)] mix-blend-overlay"></div>
      
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 blur-[120px] rounded-lg pointer-events-none"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary/5 blur-[120px] rounded-lg pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mb-20 md:mb-32">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-px w-12 bg-primary"></div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-primary font-bold">Strategic Ecosystem</span>
          </div>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-extrabold uppercase tracking-tighter leading-[0.9] mb-8">
            Strategic <br className="hidden md:block" />
            <span className="text-primary">Services</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl font-mono uppercase tracking-tight">
            Architecting authority across the full spectrum of AI and Cloud innovation.
          </p>
        </div>

        <div className="flex flex-col">
          {elixirs.map((elixir, i) => {
          const Icon = elixir.icon;
          return <div key={elixir.id} data-index={i} className="flex flex-col py-12 border-b border-border/50 last:border-b-0 group transition-all duration-500">
                <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-12">
                  {}
                  <div className="flex items-center justify-between md:flex-col md:items-start md:justify-start gap-6 shrink-0">
                    <div className="p-4 bg-primary/10 rounded-md group-hover:bg-primary/20 transition-colors">
                      <Icon className="size-8 text-primary" />
                    </div>
                    <Badge variant="outline" className="border-border/50 font-mono text-[10px] uppercase tracking-widest px-2 py-0.5">
                      {elixir.tag}
                    </Badge>
                  </div>

                  {}
                  <div className="flex-grow">
                    <h4 className="font-default text-2xl md:text-3xl font-bold text-foreground mb-4 leading-tight group-hover:text-primary transition-colors">
                      {elixir.name}
                    </h4>
                    
                    <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-default mb-4 max-w-3xl">
                      {elixir.description}
                    </p>

                    {(elixir.id === "youtube-sponsorships" || elixir.id === "content-creation-promotion") && <div className="mb-8">
                        <Link to="/MediaHubPage" newTab className="text-primary underline font-medium">
                          Visit the Media Hub
                        </Link>
                      </div>}

                    <div className="mb-6">
                      <Link to={elixir.ratesUrl} newTab className="inline-flex items-center gap-2 text-primary hover:underline font-mono text-xs uppercase tracking-wider font-bold">
                        <ExternalLink className="size-3" />
                        Click here for current rates and reach information
                      </Link>
                    </div>

                    <div className="flex items-start gap-3 bg-card/30 backdrop-blur-sm p-4 rounded-lg border border-border/30 w-fit max-w-full">
                      <CircleCheck className="size-5 text-primary shrink-0 mt-0.5" />
                      <div className="flex flex-col">
                        <span className="text-[10px] font-mono uppercase tracking-widest text-primary mb-1 font-bold">Deliverables</span>
                        <span className="text-sm font-medium text-foreground break-words">
                          {elixir.deliverables}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}